import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataserviceService } from 'src/app/dataservice.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';

@Component({
  selector: 'app-starlink-order',
  templateUrl: './starlink-order.component.html',
  styleUrl: './starlink-order.component.css'
})
export class StarlinkOrderComponent {

  @Input() fullData: any;
  @Output() orderDone = new EventEmitter<{ starlinkOrderNumber: string; nextPage: 'ihs-order' }>();

  orderForm: FormGroup;
  starlinkUrl = '';
  loading = false;
  currentUser: any;

  constructor(private fb: FormBuilder, private data: DataserviceService, private notification: NzNotificationService) {
    this.orderForm = this.fb.group({
      starlinkOrderNumber: [null, Validators.required]
    });
  }

  ngOnInit(): void {
    this.currentUser = JSON.parse(localStorage.getItem('user') || '{}');
    // console.log(this.fullData);
    if(this.fullData.starlinkOrder) {
      this.orderForm.patchValue({ starlinkOrderNumber: this.fullData.starlinkOrder });
      this.orderForm.get('starlinkOrderNumber')?.disable();
    } else {
      this.loadStarlinkLink();
    }
  }

  loadStarlinkLink(): void {
    this.loading = true;
    this.data.postData({ userId: this.currentUser.crm_id }, 'starlink/link').subscribe((r: any) => {
      this.starlinkUrl = r.data.data.Url;
      this.loading = false;
    }, e => {
      this.notification.error('Error', 'Failed to load Starlink link');
      // console.log(e);
      this.loading = false;
    });
  }

  openStarlink(): void {
    if (this.starlinkUrl) {
      window.open(this.starlinkUrl, '_blank', 'noopener,noreferrer');
    }
  }


  submit(): void {
    if (this.orderForm.invalid) return;
    const starlinkOrderNumber = this.orderForm.value.starlinkOrderNumber;
    let obj = {
      starLinkConfirmationNumber: starlinkOrderNumber,
      disclosureAcceptance: true,
      dishAccountId: null,
      agentId: this.currentUser.crm_id
    };
    this.data.postDataNoBodyDotBody(obj, 'starlink/confirm').subscribe((r: any) => {
      let obj2 = {
        // status: 'pending',
        // customer_id: this.fullData.customerId,
        // user_id: this.fullData.userId,
        // provider: this.fullData.provider,
        // provider_id: this.fullData.provider_id,
        // distributor_id: this.fullData.distributorId,
        // company_id: this.fullData.companyId,
        // generic: {
        //   starlink_order_number: starlinkOrderNumber,
        //   reserved_sku: this.fullData.catalog.reservedSku.sku
        // },
        order_id: starlinkOrderNumber,
        workOrderId: this.fullData.workOrderId
      }

      if(this.fullData.starlinkOrder) {
        this.orderDone.emit({ starlinkOrderNumber, nextPage: 'ihs-order' });
      } else {
        this.data.postDataNoBodyDotBody(obj2, 'starlink/update-starlink').subscribe((r: any) => {
        this.orderDone.emit({ starlinkOrderNumber, nextPage: 'ihs-order' });
      }, e => {
        this.notification.error('Error', 'Failed to create work order');
        // console.log(e);
      })
      }
    }, e => {
      // console.log(e);
      this.notification.error('Error', 'Failed to confirm starlink order');
    });
    //   if (this.orderForm.invalid) return;
  }
}